<template>
    <div class="atribute-title" :class="{'is-modal': !showId}">
        {{ decodeHtmlEntities(offer.name) }}
    </div>

    <template v-if="!mobile && !isOnlineGame">
        <div class="flex-row full gap-0 align-stretch">
            <div class="flex-row full">
                <div class="flex-column">
                    <div v-if="offer?.game_marketplace" class="flex-item title">
                        <img src="/img/pages/product/icons/platform.svg" alt="platform">
                        {{ $t('Platform') }}:
                    </div>
                    <div v-if="offer?.game_edition" class="flex-item title">
                        <img src="/img/pages/product/icons/edition.svg" alt="edition">
                        {{ $t('Edition') }}:
                    </div>
                    <div v-if="offer?.region_game_card" class="flex-item title">
                        <img src="/img/pages/product/icons/region.svg" alt="region">
                        {{ $t('Region') }}:
                    </div>
                </div>
                <div class="flex-column">
                    <div class="flex-item" v-if="offer?.game_marketplace" >
                        {{ offer.game_marketplace.name }}
                    </div>
                    <div class="flex-item" v-if="offer?.game_edition">
                        {{ offer.game_edition?.name }}
                    </div>
                    <div class="flex-item text-ellipsis" v-if="offer?.region_game_card" :title="offer.region_game_card?.name || offer.region_game_card?.name_tech">
                        {{ offer.region_game_card?.name || offer.region_game_card?.name_tech }}
                    </div>
                </div>
            </div>

            <div class="divider"></div>

            <div class="flex-row full">
                <div class="flex-column">
                    <div v-if="offer?.delivery_time_title" class="flex-item title">
                        <img src="/img/pages/product/icons/delivery.svg" alt="delivery">
                        {{ $t('Delivery') }}:
                    </div>
                    <div v-if="offer?.warranty_period_title" class="flex-item title">
                        <img src="/img/pages/product/icons/warranty.svg" alt="warranty">
                        {{ $t('Warranty') }}:
                    </div>
                    <div v-if="offer?.stock" class="flex-item title">
                        <img src="/img/pages/product/icons/stock.svg" alt="stock">
                        {{ $t('Stock') }}:
                    </div>
                </div>
                <div class="flex-column">
                    <div v-if="offer?.delivery_time_title" class="flex-item">
                        {{ offer.delivery_time_title }}
                        <DeliveryTooltip v-if="!offer.is_live_stock && false"/>
                    </div>
                    <div class="flex-item" v-if="offer?.warranty_period_title">
                        {{ offer.warranty_period_title }}
                    </div>
                    <div class="flex-item" v-if="offer?.stock">
                        {{ offer.stock }}
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-row id" v-if="showId">
            <div class="flex-item title">
                <img src="/img/pages/product/icons/preferences.svg" alt="preferences">
                {{ $t('ID') }}:
            </div>
            <div class="flex-item">
                <Copy :value="offer.id" :str="offer.id" />
            </div>
        </div>
    </template>

    <div v-if="!mobile && isOnlineGame && !gameService" class="flex-row full">
        <div class="flex-row full align-start online">
            <div class="flex-column gap-20">
                <div class="flex-item title">
                    <img src="/img/pages/product/icons/preferences.svg" alt="preferences">
                    {{ $t('ID') }}:
                </div>
                <div v-if="offer?.additional_data?.game_server" class="flex-item title">
                    <div class="divider-horizontal"></div>
                    <img src="/img/pages/product/icons/server.svg" alt="server">
                    {{ $t('Server') }}:
                </div>
                <div v-if="offer?.additional_data?.game_fraction" class="flex-item title">
                    <div class="divider-horizontal"></div>
                    <img src="/img/pages/product/icons/faction.svg" alt="faction">
                    {{ $t('Faction') }}:
                </div>
                <div v-if="offer?.min_order_quantity" class="flex-item title">
                    <div class="divider-horizontal"></div>
                    <img src="/img/pages/product/icons/box.svg" alt="box">
                    {{ $t('Min amount') }}:
                </div>
                <div v-if="offer?.warranty_period_title" class="flex-item title">
                    <div class="divider-horizontal"></div>
                    <img src="/img/pages/product/icons/warranty.svg" alt="warranty">
                    {{ $t('Warranty') }}:
                </div>
                <div v-if="offer?.delivery_time_title" class="flex-item title">
                    <div class="divider-horizontal"></div>
                    <img src="/img/pages/product/icons/delivery.svg" alt="delivery">
                    {{ $t('Delivery') }}:
                </div>
                <div class="flex-item title">
                    <div class="divider-horizontal"></div>
                    <img src="/img/pages/product/icons/truck.svg" alt="truck">
                    {{ $t('Delivery method') }}:
                </div>
            </div>
            <div class="flex-column gap-20">
                <div class="flex-item">
                    <Copy :value="offer.id" :str="offer.id" />
                </div>
                <div v-if="offer?.additional_data?.game_server" class="flex-item">
                    <div class="divider-horizontal"></div>
                    <span>{{ offer.additional_data.game_server }}</span>
                </div>
                <div v-if="offer?.additional_data?.game_fraction" class="flex-item">
                    <div class="divider-horizontal"></div>
                    {{ offer.additional_data.game_fraction }}
                </div>
                <div v-if="offer?.min_order_quantity" class="flex-item">
                    <div class="divider-horizontal"></div>
                    {{ offer.min_order_quantity + (productData?.currency_unit ? productData?.currency_unit : '') + ' ' + productData?.game_currency }}
                </div>
                <div v-if="offer?.warranty_period_title" class="flex-item">
                    <div class="divider-horizontal"></div>
                    {{ offer.warranty_period_title }}
                </div>
                <div v-if="offer?.delivery_time_title" class="flex-item">
                    <div class="divider-horizontal"></div>
                    {{ offer.delivery_time_title }}
                </div>
                <div class="flex-item delivery_block" v-if="offer?.delivery_methods && offer.delivery_methods.length">
                    <div class="divider-horizontal"></div>
                    {{ offer.delivery_methods.map(method => method.name).join(', ') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Copy from '/webpack-assets/vue/components/Copy.vue';
import DeliveryTooltip from '/webpack-assets/vue/templates/product/catalog/parts/DeliveryTooltip.vue';
import { decodeHtmlEntities } from '/webpack-assets/vue/utils/decodeHtmlEntities';

export default {
    name: 'DynamicAttributes',
    props: {
        offer: Object,
        mobile: Boolean,
        isOnlineGame: {
            type: Boolean,
            default: false,
        },
        gameService: {
            type: Boolean,
            default: false,
        },
        showId: {
            type: Boolean,
            default: true,
        }
    },
    components: {
        Copy,
        DeliveryTooltip,
    },
    computed: {
        getDynamicAttributes() {
            return (code) => {
                const attribute = 0;
                return attribute || null;
            };
        },
        deliveryMethods() {
            const deliveryAttr = this.offer.delivery_methods.find(attr => attr.name === 'delivery_method');
            return Array.isArray(deliveryAttr?.value) ? deliveryAttr.value : [];
        },
    },
    data() {
        return {
            modalVisible: false,
            productData: window.settings.product.additional_data
        }
    },
    methods: {
        decodeHtmlEntities,
        capitalizeText(text) {
            if (!text) return '';
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        },
    }
}
</script>

<style scoped lang="scss">
.divider {
    background-color: #E5E5E5;
    min-width: 1px;
}

.divider-horizontal {
    margin: 15px 0;
    height: 1px;
    background-color: #E5E5E5;
}

.description {
    color: #C0C3C9;
    font-size: 14px;
    line-height: 140%;
    font-family: "Avenir-Next", sans-serif;
    font-weight: 100;

    b {
        font-family: "Avenir-Next-DemiBold", sans-serif;
        font-weight: 100;
    }
}

.delivery_block {
    white-space: break-spaces !important;
}
</style>